import { axiosClient } from 'www/utils'
import type {
  ApiLpuListResponseGet,
  ApiLpuListParamsGetCount,
  ApiLpuListResponseGetCount,
} from 'www/vue_components/common/TheFilters/lpu/api/apiLpuList.types'

export default {
  get(url: string) {
    return axiosClient.get<ApiLpuListResponseGet>(url)
  },
  getCount(params: ApiLpuListParamsGetCount) {
    return axiosClient.get<ApiLpuListResponseGetCount>('/api/town/lpu-list-count/', {
      params,
      paramsSerializer: {
        indexes: null,
      },
    })
  },
}
